import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ad3110fc")

_pushScopeId("data-v-ad3110fc")
const _hoisted_1 = { class: "verification1" }
const _hoisted_2 = { class: "submit" }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("返回登录")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: _ctx.information,
      rules: _ctx.rules,
      "label-position": "top",
      "label-width": "80px",
      ref: "form"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, {
          label: "姓名",
          prop: "username"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.information.username,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.information.username = $event)),
              type: "text",
              name: "username",
              required: "required"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "身份证号",
          prop: "ID"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.information.ID,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.information.ID = $event)),
              type: "text",
              name: "ID",
              required: "required"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_2, [
          _createVNode("input", {
            type: "button",
            value: "下一步",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
          }),
          _hoisted_3,
          _createVNode(_component_router_link, { to: "login" }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
})